<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { NewsDataTable } from './NewsDataTable';
	import { NewsExclusiveArticles } from './NewsExclusiveArticles';
	import { NewsLatestPodcasts } from './NewsLatestPodcasts';
	import { NewsletterWidget } from './NewsletterWidget';
	import type { NewsChart } from '#lib/features/news/components/NewsDataChart/NewsDataTable/index.js';
	import { CustomCharts } from '#lib/websites/news/constants/custom-charts.js';
	import { NewsRoutes } from '#lib/websites/news/constants/routes.js';
	import { page } from '$app/state';

	interface Props {
		chart: Partial<NewsChart> | undefined;
		class?: string;
		showGlobalNav: boolean;
		classes?: {
			top?: string;
			newsletterWidget?: string;
			newsletterWidgetClasses?: {
				background?: string;
			};
		};
	}

	let { chart, classes, showGlobalNav, ...rest }: Props = $props();

	let id = $derived(
		Object.values(CustomCharts).includes(chart?.id as CustomCharts)
			? chart?.id
			: chart?.title?.toLowerCase()?.replaceAll(' ', '-') || ''
	);

	const scrollIntoView = (node: HTMLElement) => {
		if (
			page.route?.id === NewsRoutes.Data &&
			id &&
			window.location.hash.substring(1).startsWith(id)
		) {
			node.scrollIntoView();
		}
	};
</script>

{#if chart?.id === CustomCharts.Newsletter}
	<NewsletterWidget
		class={classes?.newsletterWidget}
		classes={classes?.newsletterWidgetClasses}
	/>
{:else if chart}
	<div
		class={twMerge(
			classNames(
				'bg-gray-0 relative rounded border border-t-0 border-gray-200 px-6 pt-6 sm:h-[490px] sm:border-t sm:px-6 sm:pb-2',
				{ 'pb-4': !!chart.entries }
			),
			rest.class
		)}
	>
		<span
			{id}
			use:scrollIntoView
			class="absolute inline-block h-[0px] translate-y-[-120px] sm:translate-y-[-180px] lg:translate-y-[-260px]"
			>&nbsp;</span
		>

		{#if chart.id === CustomCharts.HeniNewsExclusive}
			<NewsExclusiveArticles {showGlobalNav} />
		{:else if chart.id === CustomCharts.LatestPodcasts}
			<NewsLatestPodcasts {showGlobalNav} />
		{:else}
			<NewsDataTable {showGlobalNav} {classes} {id} {chart} />
		{/if}
	</div>
{/if}
